import moment from 'moment-timezone'

// Formatting for the `schedule` object mc2 returns on Accessibility Stats
// (App\Services\AuditSchedule::describe). Times are set in Chicago, which is
// how staff configure them — the local time goes into the tooltip.

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const ZONE_ABBR = 'CT'

function ordinal(n) {
	const s = ['th', 'st', 'nd', 'rd']
	const v = n % 100
	return n + (s[(v - 20) % 10] || s[v] || s[0])
}

// "07:45 CT", "Sun 20:15 CT", "12th 03:00 CT", "every 25 min"
export function scheduleWhen(schedule) {
	if (!schedule) return ''
	if (schedule.interval === 'dev') return 'every 25 min'
	const time = `${schedule.time} ${ZONE_ABBR}`
	if (schedule.interval === 'weekly') return `${DAYS[schedule.weekday]} ${time}`
	if (schedule.interval === 'monthly') return `${ordinal(schedule.monthday)} ${time}`
	return time
}

// Tooltip: whether time/day are hand-picked or the automatic staggered slot
export function scheduleTitle(schedule) {
	if (!schedule) return ''
	if (schedule.interval === 'dev') return 'Testing interval — runs whenever 25+ minutes passed since the last auto run'
	const parts = [schedule.time_custom ? 'Custom time' : 'Automatic time slot']
	if (schedule.day_custom !== null) parts.push(schedule.day_custom ? 'custom day' : 'automatic day')
	return `${parts.join(', ')} (America/Chicago)`
}

// Next scan cell: { text, title, state: 'running' | 'due' | 'scheduled' | '' }
export function nextScan(schedule, lastReport) {
	if (!schedule) return { text: '—', title: 'Auto scan is off', state: '' }
	if (lastReport && lastReport.status === 'working') {
		return { text: 'Running now', title: 'A report is still scanning', state: 'running' }
	}
	const next = moment.utc(schedule.next_run_at)
	const local = next.clone().local().format('MMM D, YYYY h:mm A')
	const chicago = next.clone().tz(schedule.timezone || 'America/Chicago').format('ddd MMM D, HH:mm')
	if (!next.isAfter(moment())) {
		return { text: 'Due now', title: `Was due ${chicago} ${ZONE_ABBR} — starts on the next 5-minute tick`, state: 'due' }
	}
	return { text: next.fromNow(), title: `${chicago} ${ZONE_ABBR} · ${local} your time`, state: 'scheduled' }
}
